import {resources} from "../../../../../../../core/models/resource/resources";
import {ColumnPropertyLazySelect} from "../../../../../../../core/types/records-table.types";

export const keyTestModalResourceType = resources['advertisement-key'];

export const propertyLazySelectDataProduct: ColumnPropertyLazySelect = {
  recourseName: 'AdvertisementKeyDto',
  providerType: 'ADVERTISEMENT_KEY_PRODUCT'
}

export const keyTestDateFields: Array<string> = [ 'date' ];

export const keyTestTimeFields: Array<string> = [ 'time' ];
